import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import get from 'lodash/get'
import moment from '../../../../lib/moment.js'
import { Header } from './header'
import Tab from './tab'
import Content from './tab-content'

export default class LOBSubmit extends React.Component {
  state={ searchResource: '' }

  handleChangeMonth = (month) => {
    const lobId = get(this.props, 'efficiencyResource.efficiencyResource.lob_id')
    this.props.getEfficiencyLOB(lobId, month)
  }

  exportEfficiencyLOB = () => {
    const lobId = get(this.props, 'efficiencyResource.efficiencyResource.lob_id')
    const month = moment(get(this.props, 'efficiencyResource.efficiencyResource.month')).format('YYYY-MM')
    this.props.exportEfficiencyLOB(lobId, month)
  }

  handleSearchResource = (e) => {
    this.setState({ searchResource: e })
  }

  render() {
    return (
      <Wrapper>
        <Header
          efficiencyResource={ get(this.props, 'efficiencyResource') }
          handleChangeMonth={ this.handleChangeMonth }
          submitEfficiency={ get(this.props, 'submitEfficiency') }
        />
        <Tab
          submitTab={ get(this.props, 'submitTab') }
          toggleTab={ get(this.props, 'toggleTabSubmit') }
          exportEfficiencyLOB={ this.exportEfficiencyLOB }
          handleSearchResource={ this.handleSearchResource }
        />
        <Content
          submitTab={ get(this.props, 'submitTab') }
          searchResource={ this.state.searchResource }
          efficiencyResource={ get(this.props, 'efficiencyResource') }
          editEfficiency={ get(this.props, 'editEfficiency') }
        />
      </Wrapper>
    )
  }
}

LOBSubmit.propTypes = {
  getEfficiencyLOB: PropTypes.func,
  exportEfficiencyLOB: PropTypes.func,
}
LOBSubmit.defaultProps = {
  getEfficiencyLOB: () => {},
  exportEfficiencyLOB: () => {},
}

const Wrapper = styled.div`
  width: 100%;
`




// WEBPACK FOOTER //
// ./src/components/efficiency-resource/tab-content/lob-submit/index.js